import _implicitStylesheets from "./cardGrid.css";
import _implicitScopedStylesheets from "./cardGrid.scoped.css?scoped=true";
import _aceListingCard from "ace/listingCard";
import _axCard from "ax/card";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<section grid skeleton${3}><figure circle${3}></figure><div title-wrapper size="auto"${3}><figure title${3}></figure><figure publisher${3}></figure><figure grid stars${3}><span star${3}></span><span star${3}></span><span star${3}></span><span star${3}></span><span star${3}></span></figure></div></section>`;
const $fragment2 = parseFragment`<section grid skeleton axis="column"${3}><figure description${3}></figure><figure description${3}></figure><figure description lastline${3}></figure><div grid tags${3}><figure tag${3}></figure><figure tag${3}></figure></div></section>`;
const stc0 = {
  props: {
    "padding": "medium",
    "shadow": "elevation-2"
  },
  key: 4
};
const stc1 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, c: api_custom_element, h: api_element, i: api_iterator, st: api_static_fragment, f: api_flatten} = $api;
  return [api_element("div", {
    attrs: {
      "grid": "",
      "flow": "wrap",
      "gap": $cmp.columnGap,
      "row-gap": $cmp.columnGap,
      "axis": "vertical",
      "align-items": "stretch"
    },
    key: 0
  }, api_flatten([api_iterator($cmp.listingRecords, function (item, index) {
    return api_element("div", {
      attrs: {
        "size": $cmp.columnSize
      },
      key: api_key(1, item.oafId)
    }, [api_custom_element("ace-listing-card", _aceListingCard, {
      props: {
        "positionIndex": index,
        "listingCardData": item
      },
      key: 2
    })]);
  }), $cmp.isLoading ? api_iterator($cmp.listingSkeletons, function (item) {
    return api_element("div", {
      attrs: {
        "size": $cmp.columnSize
      },
      key: api_key(3, item.id)
    }, [api_custom_element("ax-card", _axCard, stc0, [api_static_fragment($fragment1, 6), api_static_fragment($fragment2, 8)])]);
  }) : stc1]))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-192ub8meg5g";
tmpl.legacyStylesheetToken = "undefined-_cardGrid";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
